const styles = {
  root: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 30
  },

  paper: {
    paddingTop: 30,
    paddingBottom: 30,

    paddingLeft: 50,
    paddingRight: 50,

    display: 'flex',
    //flex: 1,
    alignItems: 'center',
    flexDirection: 'column'
  },

  logoCircle: {
    height: 150,
    width: 150,
    borderRadius: 50,
    //border: '1px solid rgba(0,0,0,0.5)',
    display: 'flex',
    flex: '1 0 auto',
    justifyContent: 'center',
    alignItems: 'center'
    //overflow: 'hidden'
  },

  title: {
    fontFamily: "'Montserrat', sans-serif",
    marginBottom: 0
  },

  subtitle: {
    fontFamily: "'Montserrat', sans-serif",
    color: 'rgba(0,0,0,0.7)'
  },

  loginButton: {
    marginTop: 20
  },

  forgotPassword: {
    fontFamily: "'Montserrat', sans-serif",
    marginTop: 20,
    cursor: 'pointer',
    color: 'rgba(0,0,0,0.7)',
    textDecoration: 'underline'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/LoginBlock/styles.js